import React from 'react'

import Row from './Row'
import Col from './Col'
import withFlex, { Flex } from './flex.style'

const FlexWithCol = withFlex(Col)
const FlexCol = (props) => <FlexWithCol flexDirection="column" {...props} />
const FlexRow = withFlex(Row)

export { Row, Col, Flex, FlexCol, FlexRow, withFlex }
